import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { TempFilterAction } from "./tempFilter.action";
 
export interface TempFilterModel {
}

@State<TempFilterModel>({
  name: 'TempFilterState',
  defaults: {}
})

@Injectable()

export class TempFilterState {
  @Selector()
  static TempFilter(state: TempFilterModel | any) {
    return state;
  }

  @Action(TempFilterAction)
  TempFilterAction({getState, patchState}: StateContext<TempFilterModel>, {payload}: TempFilterAction) {
    const state = getState();
    patchState(payload);
  }
}